/**
 * @file 聚合页
 * @author wangzhuang
 */

import {GET_ACTIVITY_GET_SERVICE, GET_INSTANCE_GETINSTANCE} from '../actions/ActionTypes';

export function activityGetService(state = {}, action) {
    switch (action.type) {
        case GET_ACTIVITY_GET_SERVICE:
            if (action.data.status === 0) {
                state = action.data;
                return state;
            }
            return {};
        default:
            return state;
    }
}

export function instanceGetinstance(state = {}, action) {
    switch (action.type) {
        case GET_INSTANCE_GETINSTANCE:
            if (action.data.status === 0) {
                state = action.data;
                return state;
            }
            return {};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/buy.js